<template>
  <div>
    <register-desktop v-if="screenType === 'desktop'"></register-desktop>
    <register-mobile v-if="screenType === 'mobile'"></register-mobile>
    <register-tablet v-if="screenType === 'tablet'"></register-tablet>
  </div>
</template>

<script>
import RegisterDesktop from "@/components/Pages/Desktop/Auth/RegisterDesktop";
import RegisterMobile from "@/components/Pages/Mobile/Auth/RegisterMobile";
import RegisterTablet from "@/components/Pages/Tablet/Auth/RegisterTablet";

export default {
  name: "RegisterMain",
  components: {RegisterDesktop, RegisterMobile, RegisterTablet},
  data() {
    return {
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop'
    }
  }
}
</script>

<style scoped>

</style>